import { render, staticRenderFns } from "./MarketingSpendDetailChannel.vue?vue&type=template&id=783c671b&"
import script from "./MarketingSpendDetailChannel.vue?vue&type=script&lang=js&"
export * from "./MarketingSpendDetailChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports